module.exports = __webpack_public_path__ + "static/media/EyeIcon.00031853.svg";